/* ── RELOD Gift Auto-Removal ──
   Reads gift variant IDs from window.RELOD_GIFT_IDS set per product page.
   Add <script src="{{ 'gift-removal.js' | asset_url }}" defer></script>
   to layout/theme.liquid before </body>
*/
(function () {

  function getGiftIds() {
    return (window.RELOD_GIFT_IDS || []).filter(function(id) { return id > 0; });
  }

  function getCart() {
    return fetch('/cart.js').then(function(r) { return r.json(); });
  }

  function removeLineItem(key) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function(r) { return r.json(); });
  }

  function enforceGiftRule() {
    var ids = getGiftIds();
    if (ids.length === 0) return;

    getCart().then(function(cart) {
      var items = cart.items;

      var giftItems = items.filter(function(item) {
        return ids.indexOf(item.variant_id) !== -1
               || (item.properties && item.properties._gift === 'true');
      });

      if (giftItems.length === 0) return;

      var hasMainProduct = items.some(function(item) {
        return ids.indexOf(item.variant_id) === -1
               && !(item.properties && item.properties._gift === 'true');
      });

      if (!hasMainProduct) {
        Promise.all(giftItems.map(function(item) {
          return removeLineItem(item.key);
        })).then(function() {
          ['cart:refresh', 'cart:updated'].forEach(function(e) {
            document.dispatchEvent(new CustomEvent(e, { bubbles: true }));
          });
        });
      }
    });
  }

  if (!window._rgpRemovalHooked) {
    window._rgpRemovalHooked = true;
    var originalFetch = window.fetch;
    window.fetch = function(url, options) {
      var result = originalFetch.apply(this, arguments);
      var isCartMutation = typeof url === 'string' && (
        url.indexOf('/cart/change') !== -1 ||
        url.indexOf('/cart/update') !== -1
      );
      if (isCartMutation) {
        result.then(function(response) {
          if (response && response.ok) {
            setTimeout(enforceGiftRule, 400);
          }
        }).catch(function(){});
      }
      return result;
    };
  }

  document.addEventListener('DOMContentLoaded', enforceGiftRule);

})();